import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'Home',
      path: '/',
      component: () => import('./../views/Home')
    },
    {
      name: 'Terms',
      path: '/terms-of-service-and-privacy-policy',
      component: () => import('./../views/Terms')
    },
    {
      name: 'Oldie',
      path: '/oldie',
      component: () => import('./../views/Oldie')
    },
    {
      path: '/404',
      name: 'NotFound',
      component: () => import('../views/states/NotFound')
    },
    { path: '*', redirect: '404' }
  ]
})



// WEBPACK FOOTER //
// ./client/router/index.js